<template>
<div class="chapter">
<div class="inner_page">
<a id="page_XX"></a>
<div class="blockquote">
<p class="noindent">“down through the starlight came the echo of that fainting cry under the wheels of the guns: ‘Murder! Murder, boys! Oh, Murder!’”</p>
<p class="right">— <em class="italic">Pvt. Robert Burdette</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Front.vue?6a770b8c